import axios from 'axios';

export const dashboardSsoApi = axios.create({
  baseURL: process.env.REACT_APP_DASHBOARD_SSO_API_URL,
});

export const dashboardApi = axios.create({
  baseURL: process.env.REACT_APP_DASHBOARD_API_URL,
});

export const catalystApi = axios.create({
  baseURL: process.env.REACT_APP_CATALYST_REST_API_URL,
});
